/** @jsxImportSource theme-ui */
import React from 'react';
import { Formik } from 'formik';
import { useGetIncentiveActionsQuery, usePostActionsMutation } from '@/store/apiService';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ActionForm, initialValues } from './ActionForm';
import RTKLoader from '@/components/RTKLoader';
import { IncentiveActionType } from '@/types/types';

type Props = {};

const mapActionTypeFromResponse = (type?: string): IncentiveActionType => {
    if (!type) {
        return initialValues.ActionType as IncentiveActionType;
    }

    const mapped = IncentiveActionType[type as keyof typeof IncentiveActionType];

    return (mapped ?? initialValues.ActionType) as IncentiveActionType;
};

const EditAction: React.FC<Props> = (props: Props) => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    const [createAction, createActionState] = usePostActionsMutation();
    const actions = useGetIncentiveActionsQuery({ Id: id ? Number(id) : undefined });

    const action = actions.data && actions.data.Results && actions.data.Results.length > 0
        ? actions.data.Results[0]
        : undefined;

    const _initialValues = action
        ? {
            ...initialValues,
            ...action,
            ActionType: mapActionTypeFromResponse(action.ActionType as string),
        }
        : initialValues;

    return (
        <RTKLoader queries={[actions]}>
            <Formik
                initialValues={_initialValues}
                enableReinitialize
                onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
                    createAction(values)
                        .unwrap()
                        .then((res) => {
                            navigate(`/actions`);
                        })
                        .catch((err) => {
                            setSubmitting(false);
                            toast.error(err.data, { autoClose: 5000 });
                        });
                }}
            >
                {(formProps) => {
                    return (
                        <>
                            <ActionForm additionalErrors={createActionState.error} {...formProps} />
                        </>
                    );
                }}
            </Formik>
        </RTKLoader>
    );
};

export default EditAction;
